<template>
    <div id="homeBox">
        <!--搜索时间头部-->
        <div class="flex mrt5">
            <el-date-picker
                    size="mini"
                    v-model="defaultValue"
                    :clearable="false"
                    type="month"
                    placeholder="选择月"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    :default-value="defaultValue">
            </el-date-picker>
            <el-select class="mrl2 wd" size="mini" v-model="i_type" placeholder="请选择类型"  clearable >
                <el-option
                        v-for="item in vcType"
                        :key="item.i_type"
                        :label="item.vc_type"
                        :value="item.i_type">
                </el-option>
            </el-select>
            <el-select class="mrl2 wd" size="mini" v-model="i_state" placeholder="请选择状态"  clearable >
                <el-option
                        v-for="item in vcState"
                        :key="item.i_state"
                        :label="item.vc_state"
                        :value="item.i_state">
                </el-option>
            </el-select>
            <el-button class="mrl15" icon="el-icon-search" circle  @click="Search" size="mini"></el-button>
        </div>
        <!--列表-->
        <el-table
                size="mini"
                ref="deliverlight"
                class="mrt5"
                :data="tableData"
                style="width: 100%"
                :height="tableHeight"
                :highlight-current-row="highlightCurrentRow"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                >
            <!--<el-table-column
                    prop="i_id"
                    label="ID"
                    width="80">
            </el-table-column>-->
            <el-table-column
                    prop="vc_ckname"
                    label="仓库名称"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_cjname"
                    label="车间部门"
                    width="250"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_gsname"
                    label="公司名称"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_type"
                    label="类型"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    label="结算时间"
                    width="100"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_state"
                    label="状态"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="file_name"
                    label="附件"
                    width="120">
                <template slot-scope="scope">
                    <a
                        :download="scope.row.file_name"
                        mce_href="#"
                        :href="file_url+'param='+encodeURI('{app:\''+baseApp+'\',i_uid:\''+i_uid+'\',token:\''+token+'\',version:\''+baseVersion+'\',fid:\''+scope.row.filenewname+',deliver\'}','utf-8')">
<!--                        {{scope.row.file_name}}-->
                        <i class="el-icon-paperclip" v-show="scope.row.file_name"></i>
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="操作"
                    width="150">
                <template slot-scope="scope">
                    <el-button @click="saveStatistics(scope.row)"  type="text" size="small" v-if="scope.row.i_id==0">生成结算</el-button>
                    <el-button @click="saveStatistics(scope.row)"  type="text" size="small" v-else :disabled="scope.row.i_state==3||scope.row.i_state==1">更改</el-button>
                    <el-button @click="WatchClick(scope.row,scope.$index)" type="text" size="small" :disabled="scope.row.i_id==0?true:false">查看</el-button>
<!--                    <el-button type="text" slot="reference" @click="submitData(scope.row)" v-show="scope.row.i_id!=0" :disabled="scope.row.i_state==3||scope.row.i_state==1">审批</el-button>-->
                    <el-button @click="costClick(scope.row)" type="text" size="small" v-show="scope.row.file_name">费用</el-button>
                    <!--<el-popover
                            placement="bottom-end"
                            width="160"
                            trigger="manual"
                            v-model="visible">
                        <p>是否提交审批？</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="visible = false">取消</el-button>
                            <el-button type="primary" size="mini" @click="flowSub()">提交</el-button>
                        </div>
                        <el-button type="text" slot="reference" @click="submitData(scope.row)" v-show="scope.row.i_id!=0" :disabled="scope.row.i_state==3||scope.row.i_state==1">审批</el-button>
                    </el-popover>-->
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <div>
            <el-pagination
                    class="fr page"
                    background
                    layout="prev, pager, next"
                    @current-change="CurrentChange"
                    :current-page.sync="currentPage"
                    :total="tableTotal"
                    :page-size="pageSize">
            </el-pagination>
        </div>
        <!--查看dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <sheet-data :sheet="sheet" @close="cancelDialog" @getStatisticsList="getStatisticsList"></sheet-data>
            </el-dialog>
        </div>
        <!--费用dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="costdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="costdialogVisible">
                <cost-list :cost="cost" @close="cancelDialog" @getStatisticsList="getStatisticsList"></cost-list>
            </el-dialog>
        </div>
        <!--自产费用dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    width="90%"
                    height="800"
                    :title="title"
                    :visible.sync="selfcostdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="selfcostdialogVisible">
                <self-costlist :application="application" @close="cancelDialog" @getStatisticsList="getStatisticsList"></self-costlist>
            </el-dialog>
        </div>
        <!--审批dialog-->
        <div :class="baseerp+'div'">
            <el-dialog
                    class="dia"
                    width="30%"
                    :title="title"
                    :visible.sync="checkdialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-loading="loading"
                    element-loading-text="正在提交中..."
                    v-if="checkdialogVisible">
                <p>是否提交审批？</p>
                <div style="text-align: right; margin: 0">
                    <el-button size="mini"   @click="checkdialogVisible = false">取消</el-button>
                    <el-button type="primary" :class="baseerp+'btn'" size="mini" :disabled="visible" @click="flowSub()">提交</el-button>
                </div>
            </el-dialog>
        </div>
        <!--表报 -->
        <div class="">
            <reportdialog  ref="mydialog"   ></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import * as API from "./api"
    import {mapActions} from "vuex";
    //import * as jUtil from '../../utils/spreadJs.js';
    import {baseerp} from "@/utils/baseUrl";
    import {baseApp} from "@/utils/baseUrl";
    import {file_url} from "@/utils/baseUrl";
    import {baseVersion} from "@/utils/baseUrl";
    import SheetData from "./SheetData";
    import CostList from "./CostList";
    import SelfCostlist from "./SelfCostlist";
    import reportdialog from "@/components/dialog"; // 错误dialog
    import eDialog from "@/components/eDialog"; // dialog
    import FaverSaver from 'file-saver'

    /*import ExcelIO from '@grapecity/spread-excelio'
    import FaverSaver from 'file-saver'
    import s from './a.json'
    import * as GC from '@grapecity/spread-sheets'
    import '@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css'
    import '@grapecity/spread-sheets-vue'
    GC.Spread.Common.CultureManager.culture("zh-cn");
    import '@grapecity/spread-sheets-resources-zh'
    import  "@grapecity/spread-sheets-print";
    //import  "@grapecity/spread-sheets-pdf";
    GC.Spread.Sheets.LicenseKey='';*/


    export default {
        name: "SettlementList",
        components: {SelfCostlist, SheetData,CostList,reportdialog,eDialog},
        data() {
            return {
                activePage:"report/res/spread.vue",
                loading:false,
                mid:0,
                title:"",
                //审批
                checkdialogVisible:false,
                //自产费用
                selfcostdialogVisible:false,
                //费用
                costdialogVisible:false,
                //
                i_state:"",
                vcState:[
                    {i_state:0,vc_state:"未提交"},
                    {i_state:3,vc_state:"审核中"},
                    {i_state:1,vc_state:"审核通过"},
                    {i_state:-1,vc_state:"审核不通过"},
                ],
                i_type:"",
                vcType:[
                    {i_type:0,vc_type:"自产"},
                    {i_type:1,vc_type:"代加工"},
                    {i_type:2,vc_type:"研发"},
                ],
                visible: false,
                //mid:0,
                file_name:"",
                filenewname:"",
                dataTime:"",
                defaultValue:"",
                sheet:{},
                dialogVisible:false,
                pageSize:10,
                currentPage:1,
                tableTotal:0,
                highlightCurrentRow:true,
                tableData:[
/*
                    {vc_type:"代加工",vc_ckname:"泰安仓库",vc_gsname:"金海威国际供应链",vc_gsnameshort:"泰安汉威",de_createtime:"20220118",vc_cjname:"聚醚车间",vc_state:"未提交",i_state:0,i_type:1},
                    {vc_type:"代加工",vc_ckname:"泰安仓库",vc_gsname:"金海威国际供应链",vc_gsnameshort:"泰安汉威",de_createtime:"20220118",vc_cjname:"聚醚车间",vc_state:"审批中",i_state:3,file_name:'baidu.com',i_type:1},
                    {vc_type:"代加工",vc_ckname:"泰安仓库",vc_gsname:"金海威国际供应链",vc_gsnameshort:"泰安汉威",de_createtime:"20220118",vc_cjname:"聚醚车间",vc_state:"审批通过",i_state:1,file_name:'baidu.com',i_type:1},
                    {vc_type:"代加工",vc_ckname:"泰安仓库",vc_gsname:"金海威国际供应链",vc_gsnameshort:"泰安汉威",de_createtime:"20220118",vc_cjname:"聚醚车间",vc_state:"审批不通过",i_state:-1,file_name:'baidu.com',i_type:1},
*/
                ],
                baseerp: "",
                file_url: "",
                baseApp:"",
                baseVersion:"",
                token:"",
                i_uid:"",
                idData:"",
                idFile:"",
                tableHeight:0,
                fileindex:'',
            }
        },

        computed:{},
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.baseApp = baseApp;
            this.baseVersion = baseVersion;
            this.file_url = file_url;
            this.token=sessionStorage.getItem('token');
            this.i_uid=sessionStorage.getItem('userid');
            //console.log('token',this.token,'i_uid',this.i_uid,this.baseApp,this.baseVersion,this.file_url,"123456456")
            this.getDateMonth();
            this.getStatisticsList();
            ////调列表接口
            this.$nextTick(function () {
                this.onResize();

            });


            },

        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-80

                // console.log(this.tableHeight)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            heightAuto(){
                this.tableHeight = window.innerHeight - this.$refs.deliverlight.$el.clientTop - 220;
            },
            ...mapActions(["getCurrentMenuId"]),

            submitData(row){
                this.checkdialogVisible=true;
                this.title="审批";
                //console.log(row,"shenipi")
                this.idData=row.i_id;
                this.idFile=row.fileId;
                this.i_type=row.i_type;
                //console.log( this.idData,this.idFile,"shenpi")

            },

            //提交审批接口
            async flowSub() {
                //console.log(this.currentPage,"页码");
                this.visible=true;
                this.loading=true;
                let param = {
                    i_mid:this.mid,
                    appid: this.sheet.value.i_id,
                    fileid: this.fileId,
                    //flowid: 32,
                    flowid: this.i_type==0?32:(this.i_type==1?33:"")
                };
                //console.log(param,"123");
                //return;
                let res = await API.flowSub(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.$refs.eDialog.onReset();
                    this.$refs.eDialog.dialogVisible=false;
                    this.checkdialogVisible=false;
                    this.$message.success(res.message);
                    this.getStatisticsList();
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //调用列表接口
            async getStatisticsList(val){
                this.visible=false;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                //console.log(val,"valllllllll从子集拿到值");
                if(val!=undefined) {
                    this.currentPage=val.pageSize;
                }
                let param = {
                    i_mid:this.mid,
                    page_size:this.currentPage,
                    page_count:10,
                    time:this.defaultValue,
                    i_type:this.i_type,
                    i_state:this.i_state,
                };
                let res = await API.getStatisticsList(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.tableTotal=res.count;
                    //console.log(res.data,"resssssss")
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //查询
            Search(){
                //console.log(this.i_state,this.i_type,this.defaultValue,"search");
                this.getStatisticsList();
                ////调列表接口
            },

            //获取当月日期
            getDateMonth(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                //const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.defaultValue=`${date.getFullYear()}-${month}`;
                this.dataTime=`${date.getFullYear()}${month}`;
                //console.log(this.dataTime,this.defaultValue,"defaultValue")
            },

            //关闭dialog
            cancelDialog(){
                if (this.title=="统计报表"){
                    this.dialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.title=="费用"){
                    this.costdialogVisible=false;
                    this.highlightCurrentRow=true;
                }else if(this.title=="自产费用"){
                    this.selfcostdialogVisible=false;
                    this.highlightCurrentRow=true;
                }
            },


            //点击费用
            costClick(row){
                //console.log(row,"row");
                if (row.i_type==0){
                    //console.log(row,"row",row.i_type);
                    this.highlightCurrentRow=true;
                    this.title="自产费用";
                    this.application={
                        //taskId:this.taskId,
                        //taskDa:this.taskDa,
                        //page_size:this.currentPage,
                        //timeData:this.defaultValue,
                        //dataTime:this.dataTime,
                        title:"自产费用",
                        value:row,
                        i_id:row.i_id,
                        i_mid:this.mid,
                    };
                    //console.log(this.application ,"自产费用row");
                    this.selfcostdialogVisible=true;

                }else if(row.i_type==1){
                    //console.log(row,"row",row.i_type);
                    this.highlightCurrentRow=true;
                    this.title="费用";
                    this.cost={
                        //taskId:this.taskId,
                        //taskDa:this.taskDa,
                        //page_size:this.currentPage,
                        //timeData:this.defaultValue,
                        //dataTime:this.dataTime,
                        title:"费用",
                        value:row,
                        i_id:row.i_id,
                        i_mid:this.mid,
                    };
                    //console.log(this.cost ,"费用row");
                    ///记得要改过来
                    //this.selfcostdialogVisible=true;
                    this.costdialogVisible=true;
                }

            },

            //点击查看
            WatchClick(row,index){
                this.fileindex=index;
                //console.log(this.fileindex,"this.fileindex");
            //    this.highlightCurrentRow=true;
            //    this.title="统计报表";
                this.sheet={
                    //taskId:this.taskId,
                    //taskDa:this.taskDa,
                    page_size:this.currentPage,
                    timeData:this.defaultValue,
                    dataTime:this.dataTime,
                    title:"统计报表",
                    value:row,
                    i_id:row.i_id,
                    i_mid:this.mid,
                };
                //console.log(this.sheet,"sheeettttt");
                this.fileId=this.sheet.value.fileId;

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                //this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })

                //console.log(this.mid,"midddddddddd==681?");
                this.$refs.eDialog.showDialog({title:"生产结算报表",btn:{f:this.saveorsubmit,l:{a:{title:"保存",name:"a1"},b:{title:"提交审批",name:"b1"}}},parm:{type:'PSettlementRpt',mid:this.mid,arg:{jssj:this.sheet.value.dt_createtime,cjid:this.sheet.value.i_cjid,gsid:this.sheet.value.i_gsid,ckid:this.sheet.value.i_ckid,type:this.sheet.value.i_type,outgsid:this.sheet.value.i_gsid_out}},w:1024,h:768});

                loading.close();

            },

            saveorsubmit(a){
                //console.log(a,'111111');
                if(a=="a1"){
                    //console.log("保存");
                    //console.log(this.sheet.value);
                   // return;
                    if(this.sheet.value.i_state==3||this.sheet.value.i_state==1){
                        this.$message.error("审批中和审批通过不能再次保存！")
                    }else{
                        //console.log(this.$refs.eDialog,"spd.excelIo111");
                        //console.log(this.$refs.eDialog.$refs.component_ref,"spd.excelIo222");
                        //console.log(this.$refs.eDialog.$refs.component_ref.spread,"spread");
                        var json = this.$refs.eDialog.$refs.component_ref.spread;
                        var ex = this.$refs.eDialog.$refs.component_ref.excelIo;
                        json = json.toJSON({includeBindingSource:true});
                        const that=this;
                        ex.save(json, async function (blob) {
                            //console.log(blob,"blob");
                            FaverSaver.saveAs(blob, 'export.xlsx');
                            //console.log(that.cTime+that.gsName+that.cjName+that.filename+".xls","fileeeeeeee");
                            let newFiles = new window.File([blob], that.sheet.value.dt_createtime+that.sheet.value.vc_gsname+that.sheet.value.vc_cjname+that.filename+".xls", {type: 'xls'});
                            let param = {
                                "IDtype": "",
                                "style": "settlementReport",
                                files:newFiles,
                                i_appid:0,
                                vc_app: "settlementReport",
                            };
                            //console.log(param,"param");
                            let res = await API.upload(param);
                            if (res.code == 1) {
                                that.fileId=res.data[0].i_id;
                                that.file_name=res.data[0].filename;
                                that.filenewname=res.data[0].filenewname;
                                //console.log(that.fileId,that.file_name,that.filenewname,"res.data")
                                ///调保存接口
                                that.updStatistics();
                                //that.$message.success(res.message);
                            } else if (res.code == -2) {
                                that.$router.push('/login');
                                that.$message.error(res.message);
                            }else{
                                that.$message.error(res.message);
                            }
                        }, function (e) {
                            //console.log(e,"12345")
                        });
                        //console.log(ex.save,"save");
                    }


                }else if(a=="b1"){
                    //console.log("审批")
                    //console.log(this.sheet.value);
                   // return;
                    if(this.fileId==0) {
                        this.$message.error("请先保存再提交审批！")
                    }else if(this.sheet.value.i_state==3||this.sheet.value.i_state==1){
                        this.$message.error("审批中和审批通过不能再次提交审批！")
                    }else{
                        this.checkdialogVisible=true;
                        this.title="审批";
                    }

                }
            },

            //生成结算/更改
            async saveStatistics(val){
                //console.log(val,"row");
                //return;
                let param = {
                    i_mid:this.mid,
                    i_cjid:val.i_cjid,
                    i_ckid:val.i_ckid,
                    i_gsid:val.i_gsid,
                    i_gsid_out:val.i_gsid_out,
                    i_type:val.i_type,
                    dt_createtime:val.dt_createtime,
                    fileId:0,
                    i_id:val.i_id,
                };
                let res = await API.saveStatistics(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.getStatisticsList();
                    /*let value={
                        pageSize:this.pageSize,

                    };
                    this.$message.success(res.message);
                    this.$emit('getStatisticsList',value);
                    this.$emit('close');*/
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //保存结算单列表
            async updStatistics(){
                //return;
                let param = {
                    i_mid:this.mid,
                    i_cjid:this.sheet.value.i_cjid,
                    i_ckid:this.sheet.value.i_ckid,
                    i_gsid:this.sheet.value.i_gsid,
                    i_gsid_out:this.sheet.value.i_gsid_out,
                    i_type:this.sheet.value.i_type,
                    dt_createtime:this.sheet.value.dt_createtime,
                    fileId:this.fileId,
                    i_id:this.sheet.value.i_id,
                };
                let res = await API.updStatistics(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.idData=this.sheet.value.i_id;
                    this.idFile=this.fileId;
                    this.i_type=this.sheet.value.i_type;
                    this.tableData[this.fileindex].file_name=this.file_name;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //分页
            CurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                this.getStatisticsList();
                ////调列表接口
            },


            /*//调用filesget接口
            getlist(){
               const that=this;
                console.log(this.filesdata+"test","filesdata")
                    axios.get('./e.json').then(function (res) {
                        //console.log(res.data,res.data.data.file_json,"getlist");
                        this.filesdata=JSON.parse(res.data.data.file_json);
                        //console.log(that.filesdata,"that.filedata")
                    })
                },*/
            /*async filesget(){
                let param = {
                    fid:"20201203203839ab46820b524afda05122893c2fe8e"
                };
                let res = await API.filesget(param);
                if (res.code == 1) {
                    this.filesdata=JSON.parse(res.data.file_json);
                    console.log(this.filesdata,"this.filesdata")
                    //this.$message.success(res.message);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/

            //加载报表
           /* spreadInitHandle: function (spread) {
                const that=this;
                axios.get('./e.json').then(function (res) {
                    //console.log(res.data,res.data.data.file_json,"getlist");
                    that.filesdata=JSON.parse(res.data.data.file_json);
                    //console.log(that.filesdata,"that.filedata")
                    console.log(that.filesdata,"this.spread.fromJSON(s)");
                    that.spread = spread;
                    that.spread.fromJSON(that.filesdata)
                })
            },*/

            //保存
            /*exportXlsx () {
                //只需要拿到json
                let ex = new ExcelIO.IO();
                let json = this.spread.toJSON();
                console.log(ex,json,"IO");
                ex.save(json, function (blob) {
                    FaverSaver.saveAs(blob, 'export.xlsx')
                }, function (e) {
                    console.log(e,"12345")
                });
                ///调保存接口
            },*/

            /*importXlsx(){
                let self = this;
                var excelIO = new ExcelIO.IO();
                console.log(excelIO,"excelIO");
                const excelFile = document.getElementById("fileDemo").files[0];
                excelIO.open(excelFile, function (json) {
                    let workbookObj = json;
                    self.spread.fromJSON(workbookObj);
                }, function (e) {
                    alert(e.errorMessage);
                });
            },*/

            /*savePdf(){
                let self = this;
                let jsonString = JSON.stringify(self.spread.toJSON());
                let printSpread = new GC.Spread.Sheets.Workbook();
                printSpread.fromJSON(JSON.parse(jsonString));

                printSpread.savePDF(function(blob) {
                    // window.open(URL.createObjectURL(blob))
                    FaverSaver.saveAs(blob,  'Hello.pdf')
                }, function(error) {
                    console.log(error);
                }, {
                    title: 'Print',
                });
            }*/

        },
        beforeDestroy() {
            window.removeEventListener('resize',this.heightAuto)
        },
    }
</script>

<style lang="scss" scoped>

    .componentContainer {
        //position: absolute;
        padding: 10px;
        left: 242px;
        top: 0;
        bottom: 20px;
        right: 0;
    }
    .spreadContainer {
        padding: 10px;
        box-shadow: 0 0 20px grey;
    }
    .spreadContainer{
        //position: absolute;
        left: 0px;
        right: 30px;
        top: 100px;
        bottom: 10px;
    }

    .spread-host {
        width: 500px;
        height: 600px;
    }

    .flex{
        justify-content: left;
    }

    .fr{
        float: right;
    }

    .mrt20{
        margin-top: 20px;
    }

    .mrl2{
        margin-left: 2px;
    }

    .mrl15{
        margin-left: 15px;
    }

    .mrt5{
        margin-top: 5px;
    }

    .mrr2{
        margin-right: 2px;
    }

    .wd{
        width: 150px;
    }

    /deep/{
        .el-dialog__body{
            word-break:unset;
            height: 620px;
            padding: 5px 20px;
        }

        .dia .el-dialog__body{
            word-break:unset;
            height: 100px;
            padding: 5px 20px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 150px;
        }
        .page {
            padding: 8px;
        }

    }

</style>